import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-35588b6a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "custom-fields-preview-banner" }

import NrIcon from '@nextrequestco/components/src/components/NrIcon/NrIcon.vue'
import NrButton from '@nextrequestco/components/src/components/NrButton/nr-button.vue'



export default /*#__PURE__*/_defineComponent({
  __name: 'custom_fields_preview_banner',
  props: {
    previewRole: {}
  },
  emits: ["toggle-modal"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createTextVNode(" Preview Perspective: "),
    _createVNode(NrIcon, {
      class: "m-left-8",
      name: "users"
    }),
    _createTextVNode(" " + _toDisplayString(props.previewRole) + " ", 1),
    _createVNode(NrButton, {
      onClick: _cache[0] || (_cache[0] = _withModifiers(
        () => {
          emit('toggle-modal', true)
        }
      , ["prevent"])),
      class: "preview-button"
    }, {
      default: _withCtx(() => [
        _createTextVNode(" Change Perspective ")
      ]),
      _: 1
    })
  ]))
}
}

})